import { render } from "./Curves.vue?vue&type=template&id=28f6c50c"
import script from "./Curves.vue?vue&type=script&lang=js"
export * from "./Curves.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__